const STORAGE_KEY = "__bl_chauffeur_invite_notice_dismissed";

export function isChauffeurInviteNoticeDismissed(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    // storage unavailable (SSR, private mode) - treat as not dismissed
    return false;
  }
}

export function dismissChauffeurInviteNotice(): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, "1");
  } catch {
    // storage unavailable - the notice will show again, which is acceptable
  }
}
